// /guide calls. Filled in by the guide work package; see platform/docs/client-inventory/web.md.
import type { Call } from './call'

export function createGuideApi(call: Call) {
  void call
  return {}
}
